module.exports = __webpack_public_path__ + "static/CircularStd-Medium-dc456ee2e6458b64d613a248caf9883b.woff";